import React from "react";
import { useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import MainLayout from "../layout/MainLayout";
import CancerIntroHeader from "../layout/Header/CancerIntroHeader";
import CancerMainFooter from "../layout/Footer/CancerMainFooter";
import ImgList from "./ImgList";

const BreastCancerMain = () => {
  // const classes = useStyles();
  const history = useHistory();
  // const [view, setView] = useState(1);
  const handleLink = (link) => {
    history.push(`/breastcancer/calculate`);
  };
  // const handleChange = (num = 1) => {
  //   setView(num);
  // };
  return (
    <MainLayout
      header={<CancerIntroHeader cancer="유방암" />}
      footer={<CancerMainFooter onClick1={handleLink} />}
    >
      <ImgList />
    </MainLayout>
  );
};

export default BreastCancerMain;
